import { z } from "zod";

const envSchema = z.object({
  VITE_API_ENDPOINT: z.string().min(1),
  VITE_ENV: z.string().min(1),
  VITE_GOOGLE_ANALYTICS_TRACKING_ID: z.string().min(1),
  VITE_IMAGE_API_ENDPOINT: z.string().min(1),
  VITE_AUTHKIT_URL: z.string().optional(),
  VITE_AUTH_PROVIDER: z.enum(["", "zitadel", "workos"]).optional(),
  VITE_E2E: z.string().optional(),
  VITE_MOCK: z.string().optional(),
  VITE_MOCK_SCENARIO: z.string().optional(),
  VITE_MOCK_WITH_AUTH: z.string().optional(),
  VITE_ZITADEL_ORG: z.string().optional(),
  VITE_ZITADEL_REDIRECT_URI: z.string().optional(),
  VITE_TERMS_OF_SERVICE_ENABLED: z.boolean(),
});

const parsed = envSchema.safeParse({
  VITE_API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
  VITE_ENV: import.meta.env.VITE_ENV,
  VITE_GOOGLE_ANALYTICS_TRACKING_ID: import.meta.env
    .VITE_GOOGLE_ANALYTICS_TRACKING_ID,
  VITE_IMAGE_API_ENDPOINT: import.meta.env.VITE_IMAGE_API_ENDPOINT,
  VITE_AUTHKIT_URL: import.meta.env.VITE_AUTHKIT_URL,
  VITE_AUTH_PROVIDER: import.meta.env.VITE_AUTH_PROVIDER,
  VITE_E2E: import.meta.env.VITE_E2E,
  VITE_MOCK: import.meta.env.VITE_MOCK,
  VITE_MOCK_SCENARIO: import.meta.env.VITE_MOCK_SCENARIO,
  VITE_MOCK_WITH_AUTH: import.meta.env.VITE_MOCK_WITH_AUTH,
  VITE_ZITADEL_ORG: import.meta.env.VITE_ZITADEL_ORG,
  VITE_ZITADEL_REDIRECT_URI: import.meta.env.VITE_ZITADEL_REDIRECT_URI,
  VITE_TERMS_OF_SERVICE_ENABLED: Boolean(
    import.meta.env.VITE_TERMS_OF_SERVICE_ENABLED,
  ),
});

if (!parsed.success) {
  console.error("Invalid environment variables:", parsed.error.format());
  throw new Error(
    `Missing or invalid environment variables: ${parsed.error.issues.map((i) => i.path.join(".")).join(", ")}`,
  );
}

export const Env = parsed.data;

export const isDemoMode =
  Env.VITE_MOCK_WITH_AUTH === "true" || Env.VITE_MOCK === "true";
